import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "kpi-dashboard" }
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "filter-row" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = { class: "filter-group" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-center align-center py-8"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "summary-inner" }
const _hoisted_10 = {
  class: "summary-icon",
  style: {"background":"rgba(33,150,243,0.1)"}
}
const _hoisted_11 = { class: "summary-value" }
const _hoisted_12 = { class: "summary-inner" }
const _hoisted_13 = {
  class: "summary-icon",
  style: {"background":"rgba(76,175,80,0.1)"}
}
const _hoisted_14 = { class: "summary-value" }
const _hoisted_15 = { class: "summary-inner" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "kpi-header" }
const _hoisted_18 = { class: "kpi-title" }
const _hoisted_19 = { class: "kpi-progress-row" }
const _hoisted_20 = { class: "kpi-target" }
const _hoisted_21 = { class: "kpi-progress-bar-wrap" }
const _hoisted_22 = { class: "kpi-progress-bar" }
const _hoisted_23 = {
  key: 0,
  class: "kpi-detalii"
}
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-center py-4"
}
const _hoisted_25 = {
  key: 1,
  class: "detalii-empty"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "detalii-header" }
const _hoisted_28 = { class: "detalii-scroll" }
const _hoisted_29 = { class: "detalii-table" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "col-denumire" }
const _hoisted_36 = {
  key: 0,
  class: "col-client"
}
const _hoisted_37 = {
  key: 1,
  class: "col-contact"
}
const _hoisted_38 = {
  key: 2,
  class: "col-valoare"
}
const _hoisted_39 = { key: 3 }
const _hoisted_40 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_41 = { class: "col-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "nav-menu-card",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              to: item.route,
              class: _normalizeClass(["nav-item", { 'active': _ctx.isActiveRoute(item.route) }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: _ctx.isActiveRoute(item.route) ? _ctx.APP_Color : '#718096',
                  size: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "filter-card mb-4",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-account", -1)
              ]))]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-label" }, "Agent:", -1)),
            _createVNode(_component_v_chip, {
              color: _ctx.tipAgent === 'Hunter' ? 'deep-orange' : _ctx.tipAgent === 'Farmer' ? 'green' : 'grey',
              size: "small",
              class: "ml-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.utilizatorAfisaj) + " — " + _toDisplayString(_ctx.tipAgent || 'Neasignat'), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-calendar-month", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "filter-label" }, "Perioadă:", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.lunaSelectata,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lunaSelectata) = $event)),
              items: _ctx.luni,
              "item-title": "label",
              "item-value": "value",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select ml-2"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_select, {
              modelValue: _ctx.anSelectat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anSelectat) = $event)),
              items: _ctx.ani,
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              class: "filter-select ml-2"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_btn, {
              color: _ctx.APP_Color,
              density: "compact",
              class: "ml-3 refresh-btn",
              loading: _ctx.loading,
              onClick: _ctx.incarcaRaport
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-refresh", -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createTextVNode(" Actualizează ", -1))
              ]),
              _: 1
            }, 8, ["color", "loading", "onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: _ctx.APP_Color,
            size: "48"
          }, null, 8, ["color"])
        ]))
      : (!_ctx.loading && _ctx.kpiItems.length === 0)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            variant: "tonal",
            class: "mb-4"
          }, {
            title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Niciun KPI configurat", -1)
            ]))]),
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createTextVNode(" Nu există KPI-uri active pentru rolul ", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.tipAgent || 'necunoscut'), 1),
              _cache[10] || (_cache[10] = _createTextVNode(". Contactați administratorul pentru a configura planul KPI. ", -1))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_row, {
              class: "mb-4",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "summary-card",
                      elevation: "1"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_v_icon, {
                              color: "#2196F3",
                              size: "24"
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-target", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.kpiItems.length), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "summary-label" }, "KPI-uri urmărite", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "summary-card",
                      elevation: "1"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_v_icon, {
                              color: "#4CAF50",
                              size: "24"
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.kpiAtinse), 1),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "summary-label" }, "KPI-uri atinse (≥ 100%)", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "summary-card",
                      elevation: "1"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", {
                            class: "summary-icon",
                            style: _normalizeStyle({ background: `rgba(${_ctx.medieColorRGB}, 0.1)` })
                          }, [
                            _createVNode(_component_v_icon, {
                              color: _ctx.medieColor,
                              size: "24"
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("mdi-chart-donut", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"])
                          ], 4),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              class: "summary-value",
                              style: _normalizeStyle({ color: _ctx.medieColor })
                            }, _toDisplayString(_ctx.medieRealizare) + "%", 5),
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-label" }, "Medie realizare globală", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { dense: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiItems, (kpi) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: kpi.KPIDefinitieID,
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: _normalizeClass(["kpi-card", { 'kpi-card--expanded': _ctx.expandedID === kpi.KPIDefinitieID }]),
                        elevation: "1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "kpi-card-inner",
                            onClick: ($event: any) => (_ctx.toggleDetaliu(kpi)),
                            style: {"cursor":"pointer"}
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_v_chip, {
                                color: kpi.TipAgent === 'Hunter' ? 'deep-orange' : 'green',
                                size: "x-small",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(kpi.TipAgent), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              (kpi.TipCalcul === 'Automat')
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    size: "x-small",
                                    color: "blue",
                                    variant: "tonal",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode(" Auto ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 1,
                                    size: "x-small",
                                    color: "grey",
                                    variant: "tonal",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                      _createTextVNode(" Manual ", -1)
                                    ]))]),
                                    _: 1
                                  })),
                              _createVNode(_component_v_icon, {
                                class: _normalizeClass(["ml-auto expand-icon", { 'expand-icon--open': _ctx.expandedID === kpi.KPIDefinitieID }]),
                                size: "18",
                                color: "grey"
                              }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("mdi-chevron-down", -1)
                                ]))]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(kpi.Denumire), 1),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", {
                                class: "kpi-realizat",
                                style: _normalizeStyle({ color: _ctx.getKPIColor(kpi.ProcentRealizat) })
                              }, _toDisplayString(kpi.Realizat), 5),
                              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "kpi-separator" }, "/", -1)),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(kpi.Target), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", {
                                  class: "kpi-progress-fill",
                                  style: _normalizeStyle({ width: Math.min(kpi.ProcentRealizat, 100) + '%', background: _ctx.getKPIColor(kpi.ProcentRealizat) })
                                }, null, 4)
                              ]),
                              _createElementVNode("span", {
                                class: "kpi-percent",
                                style: _normalizeStyle({ color: _ctx.getKPIColor(kpi.ProcentRealizat) })
                              }, _toDisplayString(kpi.ProcentRealizat) + "% ", 5)
                            ])
                          ], 8, _hoisted_16),
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              (_ctx.expandedID === kpi.KPIDefinitieID)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (_ctx.loadingDetalii[kpi.KPIDefinitieID])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _createVNode(_component_v_progress_circular, {
                                            indeterminate: "",
                                            color: _ctx.APP_Color,
                                            size: "28"
                                          }, null, 8, ["color"])
                                        ]))
                                      : (!_ctx.detalii[kpi.KPIDefinitieID]?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            _createVNode(_component_v_icon, {
                                              size: "20",
                                              color: "grey-lighten-1"
                                            }, {
                                              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                _createTextVNode("mdi-information-outline", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "ml-1" }, "Nicio înregistrare găsită pentru această perioadă.", -1))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                              _createVNode(_component_v_icon, {
                                                size: "14",
                                                color: "grey",
                                                class: "mr-1"
                                              }, {
                                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                  _createTextVNode("mdi-format-list-bulleted", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _createTextVNode(" " + _toDisplayString(_ctx.detalii[kpi.KPIDefinitieID].length) + " înregistrări ", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                              _createElementVNode("table", _hoisted_29, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", null, [
                                                    _createElementVNode("th", null, _toDisplayString(_ctx.labelColoanaDetaliu(_ctx.getSursaDate(kpi))), 1),
                                                    (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                      ? (_openBlock(), _createElementBlock("th", _hoisted_30, "Client"))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                      ? (_openBlock(), _createElementBlock("th", _hoisted_31, _toDisplayString(_ctx.labelContact(_ctx.getSursaDate(kpi))), 1))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                      ? (_openBlock(), _createElementBlock("th", _hoisted_32, "Valoare est."))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                      ? (_openBlock(), _createElementBlock("th", _hoisted_33, "Status"))
                                                      : _createCommentVNode("", true),
                                                    _cache[24] || (_cache[24] = _createElementVNode("th", null, "Data", -1))
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detalii[kpi.KPIDefinitieID], (row) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                      key: row.ID,
                                                      class: "detalii-row-link",
                                                      onClick: ($event: any) => (_ctx.navigheazaLaDetaliu(_ctx.getSursaDate(kpi), row.ID))
                                                    }, [
                                                      _createElementVNode("td", _hoisted_35, _toDisplayString(row.Denumire), 1),
                                                      (_ctx.areClient(_ctx.getSursaDate(kpi)))
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(row.Client || '—'), 1))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.areContact(_ctx.getSursaDate(kpi)))
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(row.Contact || '—'), 1))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.areValoare(_ctx.getSursaDate(kpi)))
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(row.Valoare != null ? _ctx.formatValoare(row.Valoare) : '—'), 1))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.areStatus(_ctx.getSursaDate(kpi)))
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                                            (row.Status)
                                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                  key: 0,
                                                                  size: "x-small",
                                                                  variant: "tonal",
                                                                  color: "blue"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(row.Status), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_40, "—"))
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatData(row.Data)), 1)
                                                    ], 8, _hoisted_34))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
  ]))
}